import { render, staticRenderFns } from "./YearGoals.vue?vue&type=template&id=392164b9&"
import script from "./YearGoals.vue?vue&type=script&lang=js&"
export * from "./YearGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports